import GlobalStyles from "@mui/material/GlobalStyles";
import { darken } from "@mui/system";
import { css } from "@emotion/react";
import { useTheme } from "@mui/material";

import wave from "assets/images/wave.svg";
import lines from "assets/images/bg.png";

import FlandersSansBold from "../assets/fonts/flanders-sans-bold.ttf";
import FlandersSansLight from "../assets/fonts/flanders-sans-light.ttf";
import SansRegular from "../assets/fonts/2ca7342.woff2";
import SansMedium from "../assets/fonts/ee18de6.woff2";
import IconFont from "../assets/fonts/icon-font-co-benefits.woff2";

export const AppGlobalStyles = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={
        css`
          @font-face {
            font-family: FlandersSans;
            font-style: normal;
            font-display: swap;
            font-weight: 700;
            src: local("flanders-sans-bold"),
              url(${FlandersSansBold}) format("truetype");
          }
          @font-face {
            font-family: IconFont;
            font-style: normal;
            font-display: swap;
            font-weight: 700;
            src: local("icon-font"), url(${IconFont}) format("truetype");
          }
          @font-face {
            font-family: FlandersSans;
            font-style: normal;
            font-display: swap;
            font-weight: 300;
            src: local("flanders-sans-light"),
              url(${FlandersSansLight}) format("truetype");
          }
          @font-face {
            font-family: FlandersSans;
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local("2ca7342"), url(${SansRegular}) format("woff2");
          }
          @font-face {
            font-family: FlandersSans;
            font-style: normal;
            font-display: swap;
            font-weight: 600;
            src: local("ee18de6"), url(${SansMedium}) format("woff2");
          }

          ::-webkit-scrollbar {
            width: 0.5em;
            height: 0.5em;
            background-color: #f5f5f5;
          }
          ::-webkit-scrollbar-track {
            background-color: ${theme.palette.grey[300]};
          }
          ::-webkit-scrollbar-thumb {
            border-radius: 1em;
            width: 0.75em;
            background-color: ${theme.palette.primary.main};
            &:hover {
              background-color: ${darken(theme.palette.primary.main, 0.2)};
            }
          }
          ::selection {
            color: ${theme.palette.getContrastText(theme.palette.primary.main)};
            background: ${theme.palette.primary.main};
          }
          body,
          html {
            background-image: url(${wave}), url(${lines});
            background-repeat: no-repeat, repeat;
            background-size: cover;
            scrollbar-width: "thin";
            scrollbar-color: ${theme.palette.primary.main +
            " " +
            theme.palette.background.default};
          }
          svg {
            fill: currentColor;
          }
          body,
          #app,
          #root {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: stretch;

            & > * {
              flex: 1 1 100%;
            }
            footer {
              flex: 0 1 100%;
              z-index: ${theme.zIndex.drawer + 1};
            }
            header {
              flex: 0 1 100%;
              z-index: ${theme.zIndex.drawer + 1};
            }

            main {
              flex: 1 1 100%;
              display: flex;
              position: relative;
            }
            .leaflet-marker-icon.radius-offset {
              color: ${theme.palette.error.main};
              margin-left: ${theme.spacing(1)} !important;
              margin-top: -${theme.spacing(3)} !important;
            }
            .leaflet-div-icon {
              background-color: transparent;
              border: none;
            }
            .react-joyride {
              flex: unset;
            }
            .MuiLink-root {
              cursor: pointer;
              &.disabled {
                pointer-events: none;
                text-decoration: none;
                cursor: not-allowed;
                color: ${theme.palette.grey[900]};
              }
            }
            .MuiSkeleton-root {
              transform: unset;
              transform-origin: unset;
            }
            .leaflet-container {
              font: unset;
            }
            .my-label {
              box-shadow: unset;
              background-color: transparent;
              border: unset;
              color: ${theme.palette.error.main};
              padding: 0;
              ::before {
                display: none;
              }
            }
          }
          strong,
          strong.MuiTypography-root {
            font-weight: 900;
          }
        `.styles
      }
    />
  );
};
